import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.scss';

const HeroSection = () => {
  return (
      <section className="hero">
        <div className="hero__container">
          <div className="hero__content">
            {/* Illustration on the left */}
            <div className="hero__illustration">
              <div className="hero__profile" aria-hidden="true">
                <div className="hero__icons">
                  <span className="hero__icon hero__icon--lightbulb" />
                  <span className="hero__icon hero__icon--headset" />
                  <span className="hero__icon hero__icon--home" />
                  <span className="hero__icon hero__icon--laptop" />
                  <span className="hero__icon hero__icon--solar" />
                  <span className="hero__icon hero__icon--smartphone" />
                </div>
              </div>
            </div>

            {/* Text on the right */}
            <div className="hero__text">
              <h1 className="hero__title">
                Your own digital personal assistant.<br />
                Always contactable, always on.
              </h1>
              <p className="hero__subtitle">
                Recruit an intuitive, versatile, and seamlessly integrated AI-powered virtual assistant to help you, your customers, and your business.
              </p>
              <Link to="/contact" className="button button--primary hero__cta">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
  );
};

export default HeroSection;
